module.exports = __webpack_public_path__ + "fonts/GothamPro-Light.eae82d37.woff";